module.exports = __webpack_public_path__ + "img/GALERIA-CIAZ-2021-1.d567dc78.jpg";